module.exports = __webpack_public_path__ + "img/undraw_online_payments_luau.8217f798.svg";